import React from "react";

function Categories() {
  return (
    <div className="doc-container">
      <div className="doc-content">
        <h3>About</h3>
        <div className="category-list">
          <p>If you're looking to support the project my SOL address and Nova ref link are below</p>
          <p>Solana Address: <strong>3BQfh6oruYof9o5dWtKH16g9fFPs3PLFp9oUkDWTFNmu</strong></p>
          <p>Nova Ref: <strong>https://t.me/TradeonNovaBot?start=r-abysslives</strong></p>
          
          <p style={{ margin: "30px 0" }}>Data and Web, created by <strong>@abysslives</strong> on x/twitter/telegram/discord</p>
          
          <p>Free forever, DO NOT connect wallets if requested, most likely scam. To filter through data, use the built-in column filters, AI tools, separate scripts, and third-party websites to further analyze traders. Whatever state the csv table is in after applying filters and whatnot, that is the data that will be downloaded/copied. Most data is self-explanatory. If you need help, DM me.</p>
        </div>
        <h3>Wallet Information</h3>
        <div className="category-list">
          <p><strong>address</strong> - The wallet's public address on the blockchain</p>
          <p><strong>total unrealized profit [usdc]</strong> - Current unrealized profit in USDC</p>
          <p><strong>total unrealized pnl [%]</strong> - Percentage of unrealized profit/loss</p>
          <p><strong>winrate [%]</strong> - Percentage of profitable trades vs total trades</p>
          <p><strong>sol balance [usdc]</strong> - Current SOL balance in USDC</p>
          <p><strong>7d realized profit [usdc]</strong> - Profit realized in the last 7 days</p>
          <p><strong>30d realized profit [usdc]</strong> - Profit realized in the last 30 days</p>
          <p><strong>all time profit [usdc]</strong> - Total profit since wallet creation</p>
          <p><strong>buy txns [7d]</strong> - Number of buy transactions in last 7 days</p>
          <p><strong>sell txns [7d]</strong> - Number of sell transactions in last 7 days</p>
          <p><strong>avg profit per token [usdc]</strong> - Average profit made per token traded</p>
          <p><strong>&lt;2x count</strong> - Number of trades with less than 2x return</p>
          <p><strong>2x-5x count</strong> - Number of trades with 2x to 5x return</p>
          <p><strong>&gt;5x count</strong> - Number of trades with more than 5x return</p>
          <p><strong>avg holding period [hours]</strong> - Average time holdings are kept</p>
          <p><strong>&lt; 150k fdv avg entry price</strong> - Average entry price for tokens under 150k FDV</p>
          <p><strong>&lt; 150k entries [txns]</strong> - Number of entries in &lt;150k FDV tokens</p>
          <p><strong>&lt; 150k avg total profit pnl [%]</strong> - Average PNL for &lt;150k FDV trades</p>
          <p><strong>150k - 1m fdv avg entry price</strong> - Average entry for 150k-1m FDV tokens</p>
          <p><strong>150k - 1m entries [txns]</strong> - Number of entries in 150k-1m FDV tokens</p>
          <p><strong>150k - 1m avg total profit pnl [%]</strong> - Average PNL for 150k-1m FDV trades</p>
          <p><strong>tags</strong> - Categories or labels associated with the wallet</p>
          <p><strong>date reviewed [m/d/y]</strong> - Last date the wallet was analyzed</p>
        </div>
      </div>
    </div>
  );
}

export default Categories; 